import { TimelineMax } from 'gsap/TweenMax'

function galleryMasking() {
    const tl = new TimelineMax()
  
    tl.delay(2)
      .fromTo('.o-layout__head-overlay--upper', 1, {x: 0}, {x: -140}, 0)
      .fromTo('.o-layout__head-overlay--lower', 1, {x: 0}, {x: 140}, 0)  
    return tl
  }  

export default galleryMasking
  